module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "mdl-layout__content"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('h1', {
    staticClass: "mdl-typography--headline",
    domProps: {
      "textContent": _vm._s(_vm.translate('Rapport'))
    }
  }), _vm._v(" "), ((_vm.$root.isGuest() || _vm.$route.params.code) && !_vm.isApiReport() && !_vm.isRentalReport() && !_vm.isEuropcarReport()) ? _c('div', {
    staticClass: "report-summary mdl-shadow--2dp mdl-grid"
  }, [(!parseInt(_vm.report.confirmation) || parseInt(_vm.report.confirmation) < 0) ? _c('div', {
    staticClass: "at-btn-panel"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button at-btn-accept",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('confirmReport'),
      "id": "js-accept-report"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Godta takst'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmReport(1)
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "mdl-button mdl-js-button at-btn-decline",
    attrs: {
      "href": 'mailto:' + (parseInt(_vm.report.id_client) ? _vm.report.client_email : _vm.report.surveyor_email),
      "disabled": _vm.$root.ui.isLoading('confirmReport'),
      "id": "js-decline-report"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Avslå takst'))
    },
    on: {
      "click": function($event) {
        return _vm.confirmReport(-1)
      }
    }
  })]) : _c('div', {
    domProps: {
      "textContent": _vm._s(parseInt(_vm.report.confirmation) > 0 ? 'Confirmed' : 'Declined')
    }
  })]) : _vm._e(), _vm._v(" "), (!(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport()))) ? _c('h2', {
    staticClass: "mdl-typography--title",
    domProps: {
      "textContent": _vm._s(_vm.translate('Kontaktinfo'))
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "report-summary mdl-shadow--2dp mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone"
  }, [_c('ul', {
    staticClass: "mdl-list"
  }, [_c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("person")]), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.report.contact_name)
    }
  })])]), _vm._v(" "), (!(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport()))) ? _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("email")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.report.contact_email
    },
    domProps: {
      "textContent": _vm._s(_vm.report.contact_email)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("home")]), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.report.address)
    }
  })])]), _vm._v(" "), (_vm.isApiReport()) ? _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("error")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.formatDate(_vm.report.damaged_at, true, _vm.report.report_language))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.report.service_time && 'undefined' != _vm.report.service_time) ? _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("timelapse")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.report.service_time)
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('repairdays'))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.report.referral_number) ? _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("class")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.report.referral_number)
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone"
  }, [_c('ul', {
    staticClass: "mdl-list"
  }, [(!(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport()))) ? _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("phone_android")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.report.contact_phone)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("store")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.report.firma)
    }
  })])]), _vm._v(" "), (!(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport()))) ? _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("language")]), _vm._v(" "), (_vm.report.report_language == 'no') ? _c('span', [_vm._v("Norsk rapport")]) : (_vm.report.report_language == 'en') ? _c('span', [_vm._v("Engelsk rapport")]) : (_vm.report.report_language == 'da') ? _c('span', [_vm._v("Dansk rapport")]) : (_vm.report.report_language == 'sv') ? _c('span', [_vm._v("Svensk rapport")]) : _vm._e()])]) : _vm._e()])])]), _vm._v(" "), _c('h2', {
    staticClass: "mdl-typography--title",
    domProps: {
      "textContent": _vm._s(_vm.translate('Rapport oppsummering'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-summary mdl-shadow--2dp mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone"
  }, [_c('ul', {
    staticClass: "mdl-list"
  }, [_c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("crop_7_5")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.report.id_car ? _vm.report.id_car.toUpperCase() : '')
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "mdl-list__item"
  }, [((_vm.car && _vm.car.model)) ? _c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("directions_car")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s((_vm.car && _vm.car.model) ? (_vm.car.producer + ' ' + _vm.car.model) : _vm.translate('Ukjent'))
    }
  })]) : _vm._e()]), _vm._v(" "), (!(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport()))) ? _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("swap_horiz")]), _vm._v(" "), (_vm.report.car_mileage) ? _c('span', {
    domProps: {
      "textContent": _vm._s(parseFloat(_vm.report.car_mileage) + ' km')
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("today")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.formatDate(_vm.report.created_at, true, _vm.report.report_language))
    }
  })])]), _vm._v(" "), (_vm.report.damage_date) ? _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("today")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.translate('Skadedato') + ': ' + _vm.formatDate(_vm.report.damage_date, false, _vm.report.report_language))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.report.rented_city) ? _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("location_city")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.translate('Utleieby') + ': ' + _vm.report.rented_city)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.report.insurance_company) ? _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("task")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.translate('Forsikrings selskap') + ': ' + _vm.report.insurance_company)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.report.car_market && !(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport()))) ? _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("shopping_cart")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s('Normal markedsverdi: ' + _vm.report.car_market.toLocaleString('nb-NO', {}) + ' kr')
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone"
  }, [_c('ul', {
    staticClass: "mdl-list"
  }, [(!(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport()))) ? _c('li', {
    staticClass: "mdl-list__item green"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("check_box")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.itemsStats[0] + ' ' + _vm.translate('Godkjent'))
    }
  })])]) : _vm._e(), _vm._v(" "), (!(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport()))) ? _c('li', {
    staticClass: "mdl-list__item yellow"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("warning")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.itemsStats[1] + ' ' + _vm.translate('Normal slitasje'))
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "mdl-list__item red"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("error")]), _vm._v(" "), (_vm.isApiReport() && parseInt(_vm.report.id_user) == 88) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.itemsStats[2] > 0 ? ('1 ' + _vm.translate('Skade')) : ('0 ' + _vm.translate('Skade')))
    }
  }) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.itemsStats[2] > 1 ? _vm.itemsStats[2] + ' ' + _vm.translate('Skader') : _vm.itemsStats[2] + ' ' + _vm.translate('Skade'))
    }
  })])]), _vm._v(" "), (!_vm.isWithoutPrice()) ? [(_vm.isAldReport()) ? _c('li', {
    staticClass: "mdl-list__item red"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("payment")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.translate('Takstkostnad') + ': ' + _vm.report.report_fixed_cost + ' kr eks. mva')
    }
  })])]) : _vm._e(), _vm._v(" "), (!(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport()))) ? _c('li', {
    staticClass: "mdl-list__item red"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("payment")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.translate('Totalt') + ': ' + _vm.calculateTotalCost(_vm.damageSections).toLocaleString('nb-NO', {}) + ' kr eks. mva')
    }
  })])]) : _c('li', {
    staticClass: "mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("receipt")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.translate('Sum eks. mva') + ': ' + _vm.calculateTotalCost(_vm.damageSections).toLocaleString('nb-NO', {}) + ' kr')
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.translate('Mva') + ': ' + (_vm.calculateTotalCost(_vm.damageSections) * 0.25).toLocaleString('nb-NO', {}) + ' kr')
    }
  })])]), _vm._v(" "), ((_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport()))) ? _c('li', {
    staticClass: "mdl-list__item red"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("payment")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.translate('Totalpris inkl. mva') + ': ' + (_vm.calculateTotalCost(_vm.damageSections) * 1.25).toLocaleString('nb-NO', {}) + ' kr')
    }
  })])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.discountIsActive() && !(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport()))) ? [_c('li', {
    staticClass: "mdl-list__item red"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("card_giftcard")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s('Rabatt: ' + _vm.report.discount + '%')
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "mdl-list__item red"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("payment")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s('Totalt: ' + (_vm.calculateTotalCost(_vm.damageSections) - _vm.calculateTotalCost(_vm.damageSections) / 100 * _vm.report.discount).toLocaleString('nb-NO', {}) + ' kr')
    }
  })])])] : _vm._e(), _vm._v(" "), (_vm.report.car_market && !(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport()))) ? _c('li', {
    staticClass: "mdl-list__item red"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("shopping_cart")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s('Markedsverdi: ' + (_vm.report.car_market - _vm.calculateTotalCost(_vm.damageSections)).toLocaleString('nb-NO', {}) + ' kr')
    }
  })])]) : _vm._e()], 2)]), _vm._v(" "), (!(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport()))) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.translate('Normal slitasje defineres som slitasje som må kunne forventes etter en gitt alder og kjørelengde, mens unormal slitasje er det motsatte.'))
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.isServiceHistorySection()) ? [_c('h2', {
    staticClass: "mdl-typography--title",
    domProps: {
      "textContent": _vm._s(_vm.translate('Servicehistorikk'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-summary mdl-shadow--2dp mdl-grid"
  }, [(_vm.isServiceHistory()) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--4-col-phone"
  }, [_c('ul', {
    staticClass: "mdl-list"
  }, _vm._l((_vm.report.service_history), function(history_item) {
    return _c('li', {
      staticClass: " mdl-list__item"
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content mdl-cell--6-col"
    }, [_c('i', {
      staticClass: "material-icons mdl-list__item-icon"
    }, [_vm._v("today")]), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(history_item[0])
      }
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isServiceHistory()) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--4-col-phone"
  }, [_c('ul', {
    staticClass: "mdl-list"
  }, _vm._l((_vm.report.service_history), function(history_item) {
    return _c('li', {
      staticClass: " mdl-list__item"
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content mdl-cell--6-col"
    }, [_c('i', {
      staticClass: "material-icons mdl-list__item-icon"
    }, [_vm._v("speed")]), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(history_item[1] ? history_item[1] + ' km' : '')
      }
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.report.service_history_description) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
  }, [_c('ul', {
    staticClass: "mdl-list"
  }, [_c('li', {
    staticClass: " mdl-list__item"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content mdl-cell--12-col"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-icon"
  }, [_vm._v("warning")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.report.service_history_description)
    }
  })])])])]) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.tires_items.length) ? [_c('h2', {
    staticClass: "mdl-typography--title",
    domProps: {
      "textContent": _vm._s(_vm.translate('Dekk og felg'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-summary mdl-shadow--2dp mdl-grid"
  }, [(_vm.summer_tires_items.length) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone"
  }, [_c('ul', {
    staticClass: "mdl-list"
  }, _vm._l((_vm.summer_tires_items), function(item, idx) {
    return _c('li', {
      staticClass: "mdl-list__item"
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content mdl-cell--12-col"
    }, [_c('i', {
      staticClass: "material-icons mdl-list__item-icon"
    }, [_vm._v("trip_origin")]), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(item.caption.replace('Dekk og felg - ', '') + ' - ' + item.extra_value + ' mm')
      }
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.winter_tires_items.length) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone"
  }, [_c('ul', {
    staticClass: "mdl-list"
  }, _vm._l((_vm.winter_tires_items), function(item, idx) {
    return _c('li', {
      staticClass: "mdl-list__item"
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content mdl-cell--12-col"
    }, [_c('i', {
      staticClass: "material-icons mdl-list__item-icon"
    }, [_vm._v("trip_origin")]), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(item.caption.replace('Dekk og felg - ', '') + ' - ' + item.extra_value + ' mm')
      }
    })])])
  }), 0)]) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.$root.isSurveyorCapability() || _vm.$root.isClient() || _vm.$root.isRentalCapability() || _vm.$root.isRentalCheckCapability() || _vm.$root.isEuropcarCapability() || _vm.$root.isAldCapability()) ? [_c('h2', {
    staticClass: "mdl-typography--title",
    domProps: {
      "textContent": _vm._s(_vm.translate('Merknad'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-summary mdl-shadow--2dp mdl-grid",
    on: {
      "change": function($event) {
        return _vm.saveReportForm()
      }
    }
  }, [(!_vm.isEuropcarReport() && !_vm.isAldReport()) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.surveyor_initials),
      expression: "report.surveyor_initials"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "autocomplete": "on",
      "type": "text",
      "id": "report_surveyor_initials"
    },
    domProps: {
      "value": (_vm.report.surveyor_initials)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "surveyor_initials", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "report_surveyor_initials"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Initialer/Navn takstmann'))
    }
  })]) : _vm._e(), _vm._v(" "), (!(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport())) && _vm.errors.surveyor_initials) ? _c('div', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.errors.surveyor_initials)
    }
  }) : _vm._e(), _vm._v(" "), (!(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport())) && !_vm.isEuropcarReport() && !_vm.isAldReport()) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.discount),
      expression: "report.discount"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "autocomplete": "on",
      "type": "text",
      "id": "report_discount"
    },
    domProps: {
      "value": (_vm.report.discount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "discount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "report_discount"
    }
  }, [_vm._v(_vm._s(_vm.translate('Rabatt')) + " (%)")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.report.comment),
      expression: "report.comment",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "rows": "3",
      "id": "reportComment"
    },
    domProps: {
      "value": (_vm.report.comment)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.report, "comment", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "reportComment"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Tilleggskommentar'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.service_time),
      expression: "report.service_time"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "autocomplete": "off",
      "type": "text",
      "id": "report_service_time"
    },
    domProps: {
      "value": (_vm.report.service_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "service_time", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "report_service_time"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Antall reparasjonsdager'))
    }
  })]), _vm._v(" "), (_vm.$root.isAdministrator() || (!(_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport())) && !_vm.isEuropcarReport() && !_vm.isAldReport())) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col "
  }, [_c('div', {
    staticClass: "mdl-textfield"
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    class: [_vm.report.is_dbs_tariff ? 'is-checked' : ''],
    attrs: {
      "for": "is_dbs_tariff"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.is_dbs_tariff),
      expression: "report.is_dbs_tariff"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "type": "checkbox",
      "id": "is_dbs_tariff"
    },
    domProps: {
      "checked": Array.isArray(_vm.report.is_dbs_tariff) ? _vm._i(_vm.report.is_dbs_tariff, null) > -1 : (_vm.report.is_dbs_tariff)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.report.is_dbs_tariff,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.report, "is_dbs_tariff", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.report, "is_dbs_tariff", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.report, "is_dbs_tariff", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label",
    domProps: {
      "textContent": _vm._s(_vm.translate('DBS takst er benyttet'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield"
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    class: [_vm.report.is_repaired_by_ws ? 'is-checked' : ''],
    attrs: {
      "for": "is_repaired_by_ws"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.is_repaired_by_ws),
      expression: "report.is_repaired_by_ws"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "type": "checkbox",
      "id": "is_repaired_by_ws"
    },
    domProps: {
      "checked": Array.isArray(_vm.report.is_repaired_by_ws) ? _vm._i(_vm.report.is_repaired_by_ws, null) > -1 : (_vm.report.is_repaired_by_ws)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.report.is_repaired_by_ws,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.report, "is_repaired_by_ws", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.report, "is_repaired_by_ws", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.report, "is_repaired_by_ws", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label",
    domProps: {
      "textContent": _vm._s(_vm.translate('Reparasjon er gjennomført'))
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mdl-grid",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "report-send-actions mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-phone"
  }, [(_vm.$root.isClient() && _vm.client && !_vm.report.id_parent_report) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('dataSaving')
    },
    on: {
      "click": function($event) {
        return _vm.createClientReport()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.translate('Rediger rapport')) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isEuropcarReport() && !_vm.isAldReport()) ? _c('a', {
    staticClass: "mdl-button mdl-button--raised",
    attrs: {
      "target": "_blank",
      "href": '/wp-admin/admin-ajax.php?action=at_report_pdf&id=' + _vm.report.id,
      "disabled": _vm.$root.ui.loading == 'dataSaving'
    }
  }, [_vm._v("\n              PRINT\n            ")]) : _vm._e(), _vm._v(" "), ((_vm.$root.isSurveyorCapability() || _vm.$root.isRentalCapability() || _vm.$root.isRentalCheckCapability() || _vm.$root.isEuropcarCapability() || _vm.$root.isAldCapability()) && _vm.client && !_vm.isReportClient('nettbil') && !_vm.isApiReport()) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('dataSaving')
    },
    domProps: {
      "textContent": _vm._s((_vm.isEuropcarReport() || _vm.isAldReport()) ? _vm.translate('Be om skade-takst') : _vm.translate('Send rapport til ') + _vm.client.name)
    },
    on: {
      "click": function($event) {
        return _vm.sendPdfReportToClient()
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.$root.isClient() || _vm.$root.isAdministrator() || (_vm.$root.isSurveyor() && _vm.report.contact_email && _vm.report.contact_email.toLowerCase() == 'testsenter@nettbil.no')) && !_vm.isApiReport()) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('dataSaving')
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Send rapport til ') + _vm.report.contact_name)
    },
    on: {
      "click": function($event) {
        return _vm.openPopupEmails()
      }
    }
  }) : (_vm.isApiReport()) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('dataSaving')
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Send manuell '))
    },
    on: {
      "click": function($event) {
        return _vm.openPopupEmailsManual()
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.$root.isClient() || _vm.$root.isAdministrator() || _vm.$root.isSixtAdmin()) && _vm.isApiReport()) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('dataSaving')
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Send eller avslå takst'))
    },
    on: {
      "click": function($event) {
        return _vm.openPopupActions()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$root.isEuropcarCapability() && _vm.isEuropcarReport()) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('dataSaving')
    },
    on: {
      "click": function($event) {
        return _vm.sendPdfReportToDepartment()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.translate('Send til stasjon')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$root.isAldCapability() && _vm.isAldReport()) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('dataSaving')
    },
    on: {
      "click": function($event) {
        return _vm.copyAldReport()
      }
    }
  }, [(_vm.report.report_status == 4) ? _c('span', [_vm._v(_vm._s(_vm.translate('Ny utsjekk')))]) : _vm._e(), _vm._v(" "), (_vm.report.report_status == 5) ? _c('span', [_vm._v(_vm._s(_vm.translate('Ny innsjekk')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-phone",
    staticStyle: {
      "display": "table-cell",
      "margin": "auto"
    }
  }, [(_vm.report.changed_at) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'reports-logs',
        params: {
          license: _vm.report.id_car
        }
      }
    },
    domProps: {
      "textContent": _vm._s('Sist endret ' + _vm.formatDate(_vm.report.sent_at, true, _vm.report.report_language))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.statusDisplay) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.statusDisplay + _vm.formatDate(_vm.report.sent_at, true, _vm.report.report_language))
    }
  }) : (_vm.report.report_status == 3) ? _c('span', {
    domProps: {
      "textContent": _vm._s(' Rapport avslått - ' + _vm.formatDate(_vm.report.sent_at, true, _vm.report.report_language))
    }
  }) : (_vm.report.report_status == 2) ? _c('span', {
    domProps: {
      "textContent": _vm._s(' Rapport sendt til API - midlertidig - ' + _vm.formatDate(_vm.report.sent_at, true, _vm.report.report_language))
    }
  }) : (_vm.report.report_status == 1) ? _c('span', {
    domProps: {
      "textContent": _vm._s(' Rapport sendt til API - ' + _vm.formatDate(_vm.report.sent_at, true, _vm.report.report_language))
    }
  }) : (_vm.report.sent_at) ? _c('span', {
    domProps: {
      "textContent": _vm._s('Rapport sendt ' + _vm.formatDate(_vm.report.sent_at, true, _vm.report.report_language))
    }
  }) : _c('span', [_vm._v("Rapport er ikke sendt")])], 1), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": '/wp-admin/admin-ajax.php?action=at_report_pdf&noprice=1&id=' + _vm.report.id
    }
  }, [_vm._v("Print\n            uten priser")])])] : _vm._e(), _vm._v(" "), (_vm.isAldReport() && !_vm.$route.params.code) ? _c('div', [_c('table', {
    staticClass: "mdl-data-table mdl-shadow--2dp"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.reports), function(report) {
    return _c('tr', {
      class: [_vm.getSentColor(report.report_status, report.sent_at) + '-chip', _vm.isMadeByCurrentUser(report) ? '' : 'marked'],
      attrs: {
        "id": 'report-' + report.id
      },
      on: {
        "click": function($event) {
          return _vm.openReport(report)
        }
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.formatDate(report.created_at))
      }
    }), _vm._v(" "), (_vm.$root.isEuropcarCapability() || _vm.$root.isAldCapability() || _vm.$root.isRentalCheckCapability()) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getReportStatusLabel(report))
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(report.id)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(report.id_car.toUpperCase())
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(report.contact_name)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(report.firma)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s((report.producer ? report.producer : '') + ' ' + (report.model ? report.model : ''))
      }
    }), _vm._v(" "), (report.estimate > 0) ? _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(report.estimate)
      }
    }) : _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric newpricing",
      domProps: {
        "textContent": _vm._s(report.lineitemsestimate)
      }
    }), _vm._v(" "), (report.report_status == 3) ? _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric smaller rejected",
      domProps: {
        "textContent": _vm._s(report.sent_at)
      }
    }) : (report.report_status == 2) ? _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric smaller preliminary",
      domProps: {
        "textContent": _vm._s(report.sent_at)
      }
    }) : (report.report_status == 1) ? _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric smaller confirmed",
      domProps: {
        "textContent": _vm._s(report.sent_at)
      }
    }) : (report.sent_at) ? _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric smaller",
      domProps: {
        "textContent": _vm._s(report.sent_at)
      }
    }) : _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric smaller"
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(_vm.getReportOwnerName(report))
      }
    })])
  }), _vm._v(" "), (!_vm.reports.length && !_vm.$root.ui.isLoading()) ? _c('tr', [_c('td', {
    staticClass: "mdl-data-table__cell--non-numeric",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No reports")])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "report-damages mdl-grid"
  }, [_vm._l((_vm.damageSections), function(sec) {
    return (sec.items.length) ? [_c('div', {
      staticClass: "mdl-cell--12-col"
    }, [((_vm.$route.params.code && (_vm.isApiReport() || _vm.isRentalReport() || _vm.isEuropcarReport() || _vm.isAldReport())) && sec.caption == 'Takstpunkter') ? _c('h2', {
      staticClass: "mdl-typography--title",
      domProps: {
        "textContent": _vm._s(_vm.translate('Skadedetaljer'))
      }
    }) : _c('h2', {
      staticClass: "mdl-typography--title",
      domProps: {
        "textContent": _vm._s(_vm.translate(sec.caption))
      }
    })]), _vm._v(" "), _vm._l((sec.items), function(item) {
      return [_c('div', {
        staticClass: "report-card-damage mdl-card mdl-shadow--2dp mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-phone",
        class: _vm.isLimitedReport() ? '' : _vm.getStateColor(item.state)
      }, [(item.images && item.images.length) ? _c('div', {
        staticClass: "report-card-images"
      }, _vm._l((item.images), function(imgSrc, imageIndex) {
        return _c('a', {
          staticClass: "mdl-card__title",
          style: ('background: url(' + imgSrc + ') center / cover; height: 200px;'),
          attrs: {
            "target": "_blank",
            "href": imgSrc
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.$root.showLightbox(item.images, imageIndex)
            }
          }
        })
      }), 0) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__supporting-text",
        staticStyle: {
          "box-sizing": "border-box",
          "width": "100%"
        }
      }, [(!_vm.isLimitedReport() && item.caption) ? _c('div', [_c('b', {
        domProps: {
          "textContent": _vm._s(_vm.translate(item.caption))
        }
      })]) : _vm._e(), _vm._v(" "), (item.description) ? _c('div', {
        domProps: {
          "textContent": _vm._s(item.description)
        }
      }) : _vm._e(), _vm._v(" "), (item.condition_value) ? _c('div', {
        domProps: {
          "textContent": _vm._s(item.condition_value + (item.condition_measurement ? ' ' + item.condition_measurement : ''))
        }
      }) : _vm._e(), _vm._v(" "), (item.extra_value) ? _c('div', {
        domProps: {
          "textContent": _vm._s(item.extra_caption + ' - ' + item.extra_value)
        }
      }) : _vm._e(), _vm._v(" "), _vm._l((item.lineitems), function(lineitem) {
        return (lineitem.cost > 0) ? _c('div', {
          staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label reportcard-lineitems",
          staticStyle: {
            "width": "100%",
            "display": "block"
          }
        }, [_c('span', {
          staticClass: "report_lineitem description",
          domProps: {
            "textContent": _vm._s(_vm.report.report_language == 'en' && lineitem.description_en ? lineitem.description_en : lineitem.description)
          }
        }), _vm._v(" "), (!_vm.isWithoutPrice()) ? _c('span', {
          staticClass: "report_lineitem cost",
          domProps: {
            "textContent": _vm._s(lineitem.cost + ' kr')
          }
        }) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), (!_vm.isWithoutPrice() && _vm.calculateItemCost(item)) ? _c('div', {
        staticClass: "reportcard totalprice"
      }, [_c('span', {
        staticClass: "reportcard-summary",
        domProps: {
          "textContent": _vm._s(_vm.translate('Total kostnad'))
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "reportcard-summary cost",
        domProps: {
          "textContent": _vm._s(_vm.calculateItemCost(item) + ' kr')
        }
      })]) : _vm._e()], 2)])]
    })] : _vm._e()
  })], 2)], 2), _vm._v(" "), (_vm.popup.visible) ? _c('div', {
    staticClass: "at-modal",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.popup.visible = false
      }
    }
  }, [_c('div', {
    staticClass: "at-modal-content mdl-shadow--2dp mdl-grid"
  }, [_c('p', [_vm._v("Bekreft sending av rapport til:")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popup.emails),
      expression: "popup.emails"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "autocomplete": "on",
      "type": "text",
      "id": "popup_emails"
    },
    domProps: {
      "value": (_vm.popup.emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.popup, "emails", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "popup_emails"
    }
  }, [_vm._v("For flere mottakere, separer epostadresse med\n            komma")]), _vm._v(" "), (_vm.popup_emails) ? _c('ul', {
    staticClass: "mdl-list"
  }, _vm._l((_vm.popup_emails), function(email) {
    return _c('li', {
      domProps: {
        "textContent": _vm._s(email)
      }
    })
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    on: {
      "click": function($event) {
        _vm.popup.visible = false
      }
    }
  }, [_vm._v("\n            Avbryt\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "disabled": !_vm.popup_emails || _vm.$root.ui.isLoading('dataSaving')
    },
    on: {
      "click": _vm.sendPdfReportToContact
    }
  }, [_vm._v("\n            Ja\n          ")])])])]) : _vm._e(), _vm._v(" "), (_vm.actions.visible) ? _c('div', {
    staticClass: "at-modal",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.actions.visible = false
      }
    }
  }, [_c('div', {
    staticClass: "at-modal-content mdl-shadow--2dp mdl-grid"
  }, [_c('p', [_vm._v("Velg type sending:")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actions.reasons),
      expression: "actions.reasons"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "actions_reasons"
    },
    domProps: {
      "value": (_vm.actions.reasons)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.actions, "reasons", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label"
  }, [_vm._v("Begrunnelse for evt avslag eller midlertidig rapport")])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('dataSaving')
    },
    on: {
      "click": function($event) {
        return _vm.sendReportViaAPI('rejected')
      }
    }
  }, [_vm._v("\n            Avslå\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('dataSaving')
    },
    on: {
      "click": function($event) {
        return _vm.sendReportViaAPI('preliminary')
      }
    }
  }, [_vm._v("\n            Midlertidig\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('dataSaving')
    },
    on: {
      "click": function($event) {
        return _vm.sendReportViaAPI('confirmed')
      }
    }
  }, [_vm._v("\n            Ferdig\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised cancel spaced",
    on: {
      "click": function($event) {
        _vm.actions.visible = false
      }
    }
  }, [_vm._v("\n            Avbryt\n          ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Rapport dato")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Reg.Nr")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Kontaktperson")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Firma")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Bil")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Skadekostnad")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Sendt")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Taksert av")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e36b1d94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./reports/assets/src/components/ReportForm.vue
// module id = 71
// module chunks = 0